module.exports = window.Resources;